import LicensingCheck from './Licensing';
import useLicense from './useLicense';
export default {
  LicensingCheck: LicensingCheck,
  useLicense: useLicense
};